// Where a keystroke belongs to the user rather than to a shortcut. A select is in the list because
// it answers to the arrows on its own, and a contenteditable with no value is editable too.
export const TEXT_ENTRY_SELECTOR = 'input, textarea, select, [contenteditable=""], [contenteditable="true"]'

// Whether the element - a focused one, or the target a pointer went down on - is a text entry or
// sits inside one.
export function isTextEntryElement(target: EventTarget | null | undefined): boolean {
  return target instanceof Element && !!target.closest(TEXT_ENTRY_SELECTOR)
}

export function hasTextEntryFocus(): boolean {
  return isTextEntryElement(document.activeElement)
}
